import React from 'react';

function ExternalLink(props) {
    const fill = props.fill || '#2E2C34';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M5.25 2.625H3.0625C2.82039 2.625 2.625 2.82039 2.625 3.0625V10.9375C2.625 11.1796 2.82039 11.375 3.0625 11.375H10.9375C11.1796 11.375 11.375 11.1796 11.375 10.9375V8.75M8.3125 2.625H11.375V5.6875M6.5625 7.4375L11.2188 2.78125"
                stroke={fill}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ExternalLink;